import { Component, Input, Output, EventEmitter } from '@angular/core';
import { languages } from '../locales/languages';
import { Dropdown } from '../components/dropdown/dropdown';

@Component({
  selector: 'app-language-dropdown',
  imports: [Dropdown],
  templateUrl: './language-dropdown.html',
  styleUrls: ['./language-dropdown.scss'],
})
export class LanguageDropdown {
  @Input() locale = 'en';
  @Output() readonly languageChange = new EventEmitter<string>();

  languageOptions: Array<{ label: string; value: string; subLabel: string }> = languages.map(
    lang => ({
      value: lang.Code,
      label: lang.OrthographicName,
      subLabel: lang.Name,
    }),
  );

  handleLanguageChange(locale: string): void {
    this.languageChange.emit(locale);
  }
}
